var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inbox",
    transform: "translate(-309 -25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 35,
    height: 35,
    transform: "translate(309 25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40837",
    "data-name": "Path 40837",
    d: "M1109.66,4764.571a2.639,2.639,0,0,1-.455-.039,2.4,2.4,0,0,1-2.2-2.392V4746.4a2.4,2.4,0,0,1,2.4-2.4h24.2a2.4,2.4,0,0,1,2.4,2.4v15.741a2.4,2.4,0,0,1-2.2,2.391,2.678,2.678,0,0,1-.458.04Zm23.232-1.532-7.342-7.656c0,.006-.6.6-1.593,1.628a3.117,3.117,0,0,1-2.479,1.178,3.047,3.047,0,0,1-2.346-1.178c-1.344-1.349-1.654-1.627-1.656-1.628l-7.433,7.656Zm-24.391-.9a.892.892,0,0,0,.037.255l8.025-7.864-8.062-8.075Zm17.957-7.609,8.01,7.855a.9.9,0,0,0,.034-.246v-15.668Zm-5.985,1.893a1.368,1.368,0,0,0,1.006.5,1.341,1.341,0,0,0,1.044-.494c.3-.289,9.249-9.272,10.9-10.927h-23.9C1111.179,4747.16,1120.228,4756.193,1120.472,4756.425Z",
    transform: "translate(-795 -4711.8)",
    fill: "#65676a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbox);
export default __webpack_public_path__ + "static/media/icon_inbox.9692892b63ce7e7bc96df00ec1f7248a.svg";
export { ForwardRef as ReactComponent };